export const BULK_INVOICE_EXCEL_TEMPLATE_URL =
  "https://inkle-django-files-prod.s3.ap-south-1.amazonaws.com/TEMPLATES/Template+-+Add+Invoices+in+Bulk.xlsx";

export const BULK_JOURNAL_ENTRY_EXCEL_TEMPLATE_URL =
  "https://inkle-django-files.s3.ap-south-1.amazonaws.com/Template+-+Add+Journal+Entries+in+Bulk.xlsx";

export const BULK_SALES_TAX_INVOICE_EXCEL_TEMPLATE_URL =
  "https://inkle-django-files-prod.s3.ap-south-1.amazonaws.com/Template+-+Add+Invoices+in+Bulk+for+Sales+Tax+Nexus+Tracking+(1).xlsx";

export const UPLOAD_TXN_SAMPLE_FILE =
  "https://inkle-django-files-prod.s3.ap-south-1.amazonaws.com/txns_import_sample+-+Sheet1.csv";

export const BULK_CALL_CAMPAIGN_EXCEL_TEMPLATE_URL =
  "https://inkle-django-files-prod.s3.ap-south-1.amazonaws.com/TEMPLATES/Bulk%2BCall%2BCampaign%2BTemplate_v2.csv";

export const BULK_ADD_BILLS_TEMPLATE_URL =
  "https://inkle-django-files-prod.s3.ap-south-1.amazonaws.com/TEMPLATES/Template+-+Add+Bills+in+Bulk.xlsx";

export const SAMPLE_OPEN_ITEM_FILE_URL =
  "https://inkle-django-files-prod.s3.ap-south-1.amazonaws.com/Sample+Open+Item+File.xlsx";

export const PRE_INCORPORATION_EXPENSE_MANAGEMENT_URL =
  "https://inkle-django-files-prod.s3.ap-south-1.amazonaws.com/Pre-incorporation+expense+management.xlsx";

export const BALANCE_SHEET_CSV_URL =
  "https://inkle-django-files-prod.s3.ap-south-1.amazonaws.com/TEMPLATES/Balance+Sheet+import+format.csv";

export const COA_IMPORT_SAMPLE_CSV_URL =
  "https://inkle-django-files-prod.s3.ap-south-1.amazonaws.com/TEMPLATES/COA+import+format.csv";

export const BULK_CHANNELS_EXCEL_TEMPLATE_URL =
  "https://inkle-django-files.s3.ap-south-1.amazonaws.com/Broadcast+csv+-+Sheet1.csv";

export const BULK_GROUP_ENTITY_TEMPLATE_URL =
  "https://inkle-django-files-prod.s3.ap-south-1.amazonaws.com/TEMPLATES/Template+-+Bulk+cart+action.csv";

export const QBO_ACCOUNT_LIST_CSV_URL =
  "https://inkle-django-files-prod.s3.ap-south-1.amazonaws.com/qbo_account_list.csv";

export const QBO_BILLS_AND_APPLIED_PAYMENTS_CSV_URL =
  "https://inkle-django-files-prod.s3.ap-south-1.amazonaws.com/qbo_bills_and_applied_payments.csv";

export const QBO_INVOICES_AND_RECEIVED_PAYMENTS_CSV_URL =
  "https://inkle-django-files-prod.s3.ap-south-1.amazonaws.com/qbo_Invoices_and_received_payments.csv";

export const QBO_JOURNAL_CSV_URL =
  "https://inkle-django-files-prod.s3.ap-south-1.amazonaws.com/qbo_journal.csv";

export const QBO_CUSTOMERS_CSV_URL =
  "https://inkle-django-files-prod.s3.ap-south-1.amazonaws.com/qbo_customers.csv";

export const QBO_VENDORS_CSV_URL =
  "https://inkle-django-files-prod.s3.ap-south-1.amazonaws.com/qbo_vendors.csv";

export const QBO_BALANCE_SHEET_CSV_URL =
  "https://inkle-django-files-prod.s3.ap-south-1.amazonaws.com/qbo_balance_sheet.csv";

export const PRODUCTS_IMPORT_SAMPLE_CSV_URL =
  "https://inkle-django-files-prod.s3.ap-south-1.amazonaws.com/bulk_product_import_sample.csv";
